module.exports = __webpack_public_path__ + "static/media/logo192-min.3e3ba7cc.jpeg";